import { Component, OnInit, Input, inject } from "@angular/core";
import { provideTranslocoScope } from "@jsverse/transloco";
import { FindingReportDetailsModel } from "@app/findingreport/shared/models";
import { FindingReportDataService } from "@app/findingreport/services";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";

@Component({
    selector: "linked-finding-report",
    templateUrl: "./finding-report-linked-summary.component.html",
    styleUrls: ["./finding-report-linked-summary.component.scss"],
    standalone: false,
    providers: [provideTranslocoScope("findingreport")],
})
export class FindingReportLinkedSummaryComponent implements OnInit {
    private findingReportService = inject(FindingReportDataService);
    private tabService = inject(TabService);
    private pages = inject(Pages);

    @Input() findingReportGuid: string;
    @Input() showOpenButton: false;

    detailsModel: FindingReportDetailsModel;

    ngOnInit() {
        if (this.findingReportGuid) {
            this.findingReportService.getFindingReport(this.findingReportGuid).subscribe(findingReport => {
                this.detailsModel = findingReport;
            });
        }
    }

    openFindingReport() {
        this.tabService.generateTab(
            this.pages.ImDetail,
            this.detailsModel.guid,
            `(F) ${+this.detailsModel.identifier} - ${this.detailsModel.name}`
        );
    }
}
